import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  text-align: center;
  padding: 48px 16px;
`;

const ErrorIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const ErrorTitle = styled.h2`
  margin: 0 0 16px 0;
  font-size: 20px;
  color: var(--tg-theme-text-color, #000000);
`;

const ErrorText = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  color: var(--tg-theme-hint-color, #999999);
  line-height: 1.5;
`;

const RetryButton = styled.button`
  padding: 16px 24px;
  background-color: var(--tg-theme-button-color, #2481cc);
  color: var(--tg-theme-button-text-color, #ffffff);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.9;
  }
`;

function ErrorMessage({ message, onRetry }) {
  return (
    <ErrorContainer>
      <ErrorIcon>❌</ErrorIcon>
      <ErrorTitle>Произошла ошибка</ErrorTitle>
      <ErrorText>{message}</ErrorText>
      {onRetry && (
        <RetryButton onClick={onRetry}>
          Попробовать снова
        </RetryButton>
      )}
    </ErrorContainer>
  );
}

export default ErrorMessage; 